import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  POST_CompanyInsertUpdateLicense,
  POST_GetCompanyLicenseHistory,
  POST_GetCompanyList,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";

const CompanyList = () => {
  const [showFilter, setShowFilter] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("asc");

  const handleClickSorting = (columnName) => {
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const [companyList, setCompanyList] = useState([]);
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [licenseHistoryList, setLicenseHistoryList] = useState([]);
  const [showLicenseHistoryModal, setShowLicenseHistoryModal] = useState(false);
  const [showLicenseUpdateModal, setShowLicenseUpdateModal] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Search: "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: { Search },
  } = formikFilter;

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
    };
    await post(POST_GetCompanyList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setCompanyList(response?.CompanyList);
        setIsLoading(false);
        if (page > 1 && response?.CompanyList?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  const getLicenseHistory = async (companyID, companyName) => {
    setSelectedCompanyName(companyName);
    setIsLoading(true);
    await post(POST_GetCompanyLicenseHistory, { CompanyIDEncrypted: companyID })
      .then((response) => {
        setLicenseHistoryList(response?.LicenseHistList);
        setShowLicenseHistoryModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const validationSchema = Yup.object().shape({
    LicenseFile: Yup.string().trim().required("License File is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      LicenseFile: "",
      CompanyIDInputEncrypted: "",
      LicenseFileKey: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { CompanyIDInputEncrypted, LicenseFileKey },
  } = formik;

  const AddCompany = () => {
    formik.resetForm();
    setShowLicenseUpdateModal(true);
  };

  const UpdateLicense = (companyID, companyName) => {
    setSelectedCompanyName(companyName);
    formik.resetForm();
    formik.setFieldValue("CompanyIDInputEncrypted", companyID);
    setShowLicenseUpdateModal(true);
  };

  const uploadLicenseFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      // var pattern = /(.appegic)$/;

      // if (!file.type.match(pattern)) {
      //   warningMessage("Select valid file!");
      //   formik.setFieldValue("LicenseFile", "");
      //   formik.setFieldValue(
      //     "LicenseFileKey",
      //     Math.random().toString(9).substring(2, 9)
      //   );
      // } else {
      formik.setFieldValue("LicenseFile", file);
      // }
    } else {
      formik.setFieldValue("LicenseFile", "");
      formik.setFieldValue(
        "LicenseFileKey",
        Math.random().toString(9).substring(2, 9)
      );
    }
  };

  const handleValidSubmit = async (values) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append(
      "CreatedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );
    formData.append("CompanyIDInputEncrypted", values?.CompanyIDInputEncrypted);
    formData.append("LicenseFile", values?.LicenseFile);
    await postFormData(POST_CompanyInsertUpdateLicense, formData)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setShowLicenseUpdateModal(false);
          getData();
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Companies</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                      // setShowFilter(false);
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      AddCompany();
                    }}
                  >
                    <i className="fa-solid fa-plus me-2"></i>Add
                  </button>
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Search"
                              name="Search"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  // className="btn btn-primary btn-sm mb-1"
                                  className="btn btn-primary btn-sm"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="Companies-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="Companies-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="4%"></th>
                        <th
                          style={{
                            width: "46%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CompanyName");
                          }}
                        >
                          Company Name
                          <span className="ml-1">
                            {sortBy == "CompanyName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("MobileNo");
                          }}
                        >
                          Mobile
                          <span className="ml-1">
                            {sortBy == "MobileNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "30%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("EmailID");
                          }}
                        >
                          Email
                          <span className="ml-1">
                            {sortBy == "EmailID" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("CityName");
                          }}
                        >
                          City
                          <span className="ml-1">
                            {sortBy == "CityName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {companyList?.length > 0 ? (
                        companyList?.map((item, indx) => (
                          <tr key={indx}>
                            <td>
                              <Link
                                to="#"
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Update License"
                                onClick={() => {
                                  UpdateLicense(
                                    item?.CompanyIDEncrypt,
                                    item?.CompanyName
                                  );
                                }}
                              >
                                {SVGICON.EditPrimary}
                              </Link>
                              <Link
                                to="#"
                                // className="icon-box icon-box-md bg-primary-light"
                                className="icon-box icon-box-md me-1"
                                title="License History"
                                onClick={() => {
                                  getLicenseHistory(
                                    item?.CompanyIDEncrypt,
                                    item?.CompanyName
                                  );
                                }}
                              >
                                <i className="fa fa-history"></i>
                              </Link>
                            </td>
                            <td>{item?.CompanyName}</td>
                            <td>{item?.MobileNo}</td>
                            <td>{item?.EmailID}</td>
                            <td style={{ textAlign: "left" }}>
                              {item?.CityName}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={showLicenseHistoryModal}
            onHide={setShowLicenseHistoryModal}
            size="lg"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <Modal.Header>
                <Modal.Title>
                  License History - {selectedCompanyName}
                </Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowLicenseHistoryModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="LicenseHistory-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="LicenseHistory-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="8%">Sr No</th>
                              <th width="18%">Validity From</th>
                              <th width="16%">Validity To</th>
                              <th width="16%">No of Branch</th>
                              <th width="18%">No of Department</th>
                              <th width="24%" style={{ textAlign: "left" }}>
                                Created On
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {licenseHistoryList?.length > 0 ? (
                              licenseHistoryList?.map((item, indx) => (
                                <tr>
                                  <td>{item.SrNo}</td>
                                  <td>{item.ValidityFromDate}</td>
                                  <td>{item.ValidityToDate}</td>
                                  <td>{item.NoOfBranch}</td>
                                  <td>{item.NoOfDepartment}</td>
                                  <td style={{ textAlign: "left" }}>
                                    {item.CreatedOn}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} style={{ textAlign: "left" }}>
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
            </Spin>
          </Modal>
          <Modal
            className="fade"
            show={showLicenseUpdateModal}
            onHide={setShowLicenseUpdateModal}
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      {CompanyIDInputEncrypted
                        ? `Update License - ${selectedCompanyName}`
                        : "Create Company"}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowLicenseUpdateModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={12}>
                        <div className="mb-2">
                          <label className="mb-1">License File</label>
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="LicenseFile"
                            key={LicenseFileKey || ""}
                            onChange={(e) => {
                              uploadLicenseFile(e);
                            }}
                          />
                          <ErrorMessage
                            name="LicenseFile"
                            component="div"
                            className="invalid-feedback animated fadeInUp"
                            style={{ display: "block" }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      // variant="primary"
                      variant="primary btn-sm"
                      type="submit"
                    >
                      <i className="fa-solid fa-floppy-disk"></i>{" "}
                      {CompanyIDInputEncrypted ? "Update License" : "Submit"}
                    </Button>
                    <Button
                      // variant="danger light"
                      variant="danger btn-sm"
                      onClick={() => setShowLicenseUpdateModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default CompanyList;
